export default {
  title: "تهانينا",
  subtitle: "أنت الآن جاهزٌ لاستكشاف Koinz!",
  goToDashboard: "الذهاب إلى المنصة",
};
